import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

type BackgroundColor = 'grey';
type FloatBox = 'left' | 'right' | 'none';

/**
 *  @class InfoBoxComponent
 *  @desc displays an array of strings as a nice list inside a grey box.
 *      Headline, background color and wether the box floats can also
 *      be set.
 *  @example
 *      <app-info-box
 *          [bulletPoints]="['first', 'second', 'third']" // array of strings displayed as bullet point list
 *          floatBox="left" // the box floats left
 *          headline="Example Box" // the headline of the box
 *          backgroundColor="grey" // set a background color class (grey is default, others not implemented yet)
 *      >
 *          <p>This paragraph will be displayed inside the box!</p>
 *      </app-info-box>
 *
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-info-box',
    imports: [NgClass],
    templateUrl: './info-box.component.html',
    styleUrl: './info-box.component.scss',
})
export class InfoBoxComponent {
    public headline = input.required<string>();
    public bulletPoints = input<string[]>([]);
    public backgroundColor = input<BackgroundColor>('grey');
    public floatBox = input<FloatBox>('none');
}
